import { createConfirmation } from 'react-confirm';
import ConfirmDialog from '../components/core/confirm-dialog/ConfirmDialog';

const confirm = createConfirmation(ConfirmDialog);

function confirmDialog(confirmation, options = {}) {
  return confirm({ confirmation, options });
}

export default confirmDialog;